import { Box, Button, Card, Divider, Grid, Tab, Tabs, Typography } from '@mui/material';
import FormProvider from 'src/components/hook-form';
import AddEditActivity from '../activity-page/activity-page';
import { useRouter } from 'src/routes/hooks';
import Iconify from 'src/components/iconify';
import { useCallback, useState } from 'react';
import Labors from './labours/assign-labours'
import Material from './material/assign-material';
import Equipment from './equipment/assign-equipment';
import Subcontractor from './subcontractor/assign-subcontractor';
import OtherCost from './other-cost/assign-other-cost';
import SmallTools from './small-tools/assign-small-tools';
export default function AssignPage({selectedDate,close,gantt}) {
  const [currentTab, setCurrentTab] = useState('Labors');

  const router = useRouter();
  const handleChangeTab = useCallback((event, newValue) => {
    setCurrentTab(newValue);
  }, []);

  const renderTabContent = () => {
    switch (currentTab) {
      case 'Labors':
        return <Labors selectedDate={selectedDate} close={close}  gantt={gantt}/>;
      case 'Material':
        return <Material selectedDate={selectedDate} close={close} gantt={gantt}/>;
      case 'Equipment':
        return <Equipment selectedDate={selectedDate} close={close} gantt={gantt}/>;
      case 'Subcontractor':
        return <Subcontractor selectedDate={selectedDate} close={close} gantt={gantt}/>;
      case 'Small Tools':
        return <SmallTools selectedDate={selectedDate} close={close} gantt={gantt}/>;
      case 'Other Cost':
        return <OtherCost selectedDate={selectedDate} close={close} gantt={gantt}/>;
      default:
        return null;
    }
  };

  return (
    <>
    
        <Box sx={{mt:2}}>
          <Tabs value={currentTab} onChange={handleChangeTab}>
            {[
              { label: 'Labors', value: 'Labors' },
              { label: 'Material', value: 'Material' },
              { label: 'Equipment', value: 'Equipment' },
              { label: 'Subcontractor', value: 'Subcontractor' },
              { label: 'Small Tools', value: 'Small Tools' },
              { label: 'Other Cost', value: 'Other Cost' },
            ].map((tab) => (
              <Tab key={tab.value} value={tab.value} label={tab.label} />
            ))}
          </Tabs>
        </Box>
        <Divider sx={{ mb: 4 }} />
        {renderTabContent()}
   
    </>
  );
}
